export const CAPTION_CATEGORY_LIST = [
  'Behind the Scenes',
  'My Why',
  'Personal Insight',
  'Encouragement',
  'About Me',
  'Benefits',
  'Showcase Product/Service',
  'Holiday'
] as const

export type CaptionSetType = {
  caption: string;
  captionPlainText: string;
  _id?: string;
  id: string;
  index: number;
  issue: string;
  photoIdeas: string;
  subTitle: string;
  category: typeof CAPTION_CATEGORY_LIST[number];
  tags: { id: string; label: string }[];
  showInIssue: boolean;
  suggested: boolean;
  issueTitle: string | null;
  thumbnail: string;
  title: string;
  updateDate?: any;
  syncDate: any;
  image?: any;
  userCaption?: {
    _id: string;
    used: boolean;
    liked: boolean;
    addedDate: any;
    captionSetId: string;
    user: string;
  };
}
